import { DataQaLocators, SocialNetworkCode, SocialNetworkLabelsGA, SocialNetworks } from '../../emun/social'
import { Languages } from '../../interfaces/common'

export interface IButtons {
  className: string
  id: SocialNetworks
  langs: Languages[]
  code: SocialNetworkCode
  dataQaLocator: string
  gaEventLabel: SocialNetworkLabelsGA
}

type TStyles = { [key: string]: string }

export const getSocialButtons = (styles: TStyles): IButtons[] => [
  {
    className: styles.socialVk,
    code: SocialNetworkCode.Vk,
    id: SocialNetworks.Vk,
    langs: [Languages.RU],
    dataQaLocator: DataQaLocators.Vk,
    gaEventLabel: SocialNetworkLabelsGA.Vk,
  },
  {
    className: styles.socialGoogle,
    code: SocialNetworkCode.Google,
    id: SocialNetworks.Google,
    langs: [Languages.RU, Languages.KZ, Languages.UZ],
    dataQaLocator: DataQaLocators.Google,
    gaEventLabel: SocialNetworkLabelsGA.Google,
  },
  {
    className: styles.socialMail,
    code: SocialNetworkCode.Mail,
    id: SocialNetworks.Mail,
    langs: [Languages.RU],
    dataQaLocator: DataQaLocators.Mail,
    gaEventLabel: SocialNetworkLabelsGA.MailRu,
  },
  {
    className: styles.socialOk,
    code: SocialNetworkCode.Ok,
    id: SocialNetworks.Ok,
    langs: [Languages.RU],
    dataQaLocator: DataQaLocators.Ok,
    gaEventLabel: SocialNetworkLabelsGA.Ok,
  },
  {
    className: styles.socialFacebook,
    code: SocialNetworkCode.Facebook,
    id: SocialNetworks.Facebook,
    langs: [Languages.KZ, Languages.UZ],
    dataQaLocator: DataQaLocators.Facebook,
    gaEventLabel: SocialNetworkLabelsGA.Fb,
  },
  {
    className: styles.socialYandex,
    code: SocialNetworkCode.Yandex,
    id: SocialNetworks.Yandex,
    langs: [Languages.RU, Languages.KZ],
    dataQaLocator: DataQaLocators.Yandex,
    gaEventLabel: SocialNetworkLabelsGA.Yandex,
  },
]
